// Central UI version — mirrors /VERSION at the repo root.
// Rewritten automatically by the Makefile 'ui' target before 'vite build'.
export const NC_VERSION = '1.0.59'
